<template>
  <!-- <div class="boxall"> -->
  <!-- <div class="tit04">地图总览</div> -->
  <div class="mapbox">
    <div class="data">
      <div class="money">
        <div class="item-info">
          <div class="item-label">交易额</div>
          <div class="item-value">
            <span class="num num2">{{ money }}</span>
            <span class="unit">万元</span>
          </div>
        </div>
      </div>

      <div class="number">
        <div class="item-info">
          <div class="item-label">交易量</div>
          <div class="item-value">
            <span class="num num1">{{ number }}</span>
            <span class="unit">吨</span>
          </div>
        </div>
      </div>
    </div>

    <div class="map-img">
      <div class="bg-image">
        <!-- <div class="area-1" @click="openDialog1"></div>

        <el-dialog
          title="大河镇产业数据"
          :visible.sync="dialogVisible"
          custom-class="field-dialog"
          :modal="false">
          <div class="dialog-container">
            <div class="dialog-col">
              <div class="col-title">基本信息</div>
              <div class="col-content">
                <div class="dialog-row">
                  <span class="key">面积</span>
                  <span class="val">24.36亩</span>
                </div>
                <div class="dialog-row">
                  <span class="key">产量</span>
                  <span class="val">1200kg</span>
                </div>
              </div>
            </div>

            <div class="dialog-col">
              <div class="col-title">养殖信息</div>
              <div class="col-content">
                <div class="dialog-row">
                  <span class="key">养殖周期</span>
                  <span class="val">3-8月</span>
                </div>
                <div class="dialog-row">
                  <span class="key">投放数量</span>
                  <span class="val">500kg</span>
                </div>
              </div>
            </div>

            <div class="dialog-col">
              <div class="col-title">农事操作</div>
              <div class="col-content">
                <div class="dialog-row">
                  <span class="key">姓名</span>
                  <span class="val">张三</span>
                </div>
                <div class="dialog-row">
                  <span class="key">电话</span>
                  <span class="val">138xxxx</span>
                </div>
              </div>
            </div>
          </div>
        </el-dialog> -->
      </div>
    </div>
  </div>

  <!-- </div> -->
</template>

<script>
// import { getDashboardData } from '@/api/getData'
import { mapGetters } from 'vuex'

export default {
  name: 'CenterMap',

  data() {
    return {
      number: 0,
      money: 0,
      countTimer: null,

      dialogVisible: false
    }
  },

  created() {
    this.startCountUpTimer()
  },

  computed: {
    ...mapGetters('dashboard', ['marketInfo']),

    numberTarget() {
      const { year_weight } = this.marketInfo
      if (!year_weight) return 0

      return +(year_weight / 2000).toFixed(1)
    },

    moneyTarget() {
      const { year_amount } = this.marketInfo
      if (!year_amount) return 0

      return +(year_amount / 10000).toFixed(1)
    }
  },

  // 监听 marketInfo，数据一进来就触发动画
  watch: {
    marketInfo: {
      immediate: true, // 如果数据已经在 store 里了，立刻触发
      handler(val) {
        if (val && val.year_amount) {
          this.countUp('money', this.moneyTarget, 4000)
          this.countUp('number', this.numberTarget, 4000)
        }
      }
    }
  },

  beforeDestroy() {
    clearInterval(this.countTimer)
  },

  methods: {
    // 每30秒触发一次数字动画
    startCountUpTimer() {
      this.countTimer = setInterval(() => {
        this.countUp('money', this.moneyTarget, 5000)
        this.countUp('number', this.numberTarget, 5000)
      }, 30 * 1000)
    },

    countUp(key, target, duration = 2000) {
      const start = performance.now()
      const tick = now => {
        const elapsed = now - start
        const progress = Math.min(elapsed / duration, 1)
        const eased = 1 - Math.pow(1 - progress, 4)
        this[key] = +(eased * target).toFixed(2)
        if (progress < 1) requestAnimationFrame(tick)
        else this[key] = target
      }
      requestAnimationFrame(tick)
    },

    openDialog1() {
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped>
.mapbox {
  height: 100%;
  padding: 16px;
}

.data {
  display: flex;
  justify-content: space-evenly;
  height: 12%;
}

.number .money {
  font-size: 70px;
  font-weight: bold;
  color: #00cfff;
  font-family: ds-digitalnormal !important;
  display: inline-block;
  width: 200px;
  text-align: right; /* 数字右对齐，视觉上更稳 */

  /* 
  background-image: url('../assets/images/bg_middle_center.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: calc(100% - 16px) calc(100% - 16px); */
}

/* 右侧文字区域 — 垂直居中 */
.item-info {
  /* flex: 1; */
  display: flex;
  /* flex-direction: column; */
  justify-content: center;
  padding-bottom: 4px;
}

/* 第一行：数字 + 单位 */
.item-value {
  display: flex;
  align-items: baseline;
  gap: 18px;
}

.num {
  font-size: 70px;
  font-weight: bold;
  color: #00cfff;
  font-family: ds-digitalnormal !important;
  font-variant-numeric: tabular-nums;
  text-align: right;
}

.num1 {
  min-width: 220px;
}

.num2 {
  min-width: 220px;
}

.unit {
  font-size: 28px;
  color: #7ecfea;
}

/* 第二行：描述 */
.item-label {
  font-size: 24px;
  color: #8fb8c8;
  display: flex;
  justify-content: right;
  align-items: flex-end;
  margin-bottom: 8px;
}

.map-img {
  height: 87%;
  position: relative;
}

.bg-image {
  width: 100%;
  height: 100%;

  background: url('../assets/images/bg_middle_pic1.jpg') no-repeat center center;
  background-size: cover;
  border-radius: 12px;

  /* position: relative; */
}

.map-charts {
  height: 100%;
  width: 100%;
}

.area-1 {
  width: 50px;
  height: 50px;
  border: 1px solid red;
  position: absolute;
  top: 170px;
  left: 335px;
  cursor: pointer;
}

/* 弹窗样式 */
::v-deep .el-dialog__header {
  padding: 8px 20px 20px 8px;
  text-align: center;
}

::v-deep .el-dialog__headerbtn {
  top: 8px;
  right: 8px;
}

::v-deep .el-dialog__body {
  padding: 18px 15px;
}

::v-deep .field-dialog {
  background: rgba(0, 20, 50, 0.95);
  border-radius: 12px;
  border: 2px solid rgb(5 175 211 / 91%);
  box-shadow: 0 0 20px rgba(0, 191, 255, 0.4), inset 0 0 50px rgba(0, 191, 255, 0.5),
    inset 0 0 2px rgba(255, 255, 255, 0.3);
  margin-top: 350px !important;
  width: 600px;
  min-height: 300px;
}

::v-deep .field-dialog .el-dialog__title {
  color: #00e5ff;
  font-size: 16px;
}

::v-deep .field-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #00e5ff;
}

.dialog-row {
  display: flex;
  justify-content: space-between;
  padding: 6.4px 0;
  border-bottom: 1px solid rgba(0, 229, 255, 0.15);
  font-size: 11.2px;
}

.key {
  color: #7ecfff;
}

.val {
  color: #ffffff;
}

/* 三列容器 */
.dialog-container {
  display: flex;
  gap: 12px;
}

/* 每一列 */
.dialog-col {
  flex: 1; /* 三列等宽 */
  border: 1px solid rgba(0, 229, 255, 0.3);
  border-radius: 6.4px;
  padding: 9.6px;
  background: rgba(0, 229, 255, 0.05);
  min-height: 180px;
}

/* 列标题 */
.col-title {
  color: #00e5ff;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  padding-bottom: 8px;
  margin-bottom: 8px;
  border-bottom: 1px solid rgba(0, 229, 255, 0.3);
}

/* 每行数据 */
.dialog-row {
  display: flex;
  justify-content: space-between;
  padding: 5.6px 0;
  border-bottom: 1px solid rgba(0, 229, 255, 0.1);
  font-size: 10.4px;
}
</style>
